import { navigate } from '../lib/route.ts'

/**
 * The two halves of how an account compares pharmaceutical forms (#607).
 *
 * The forms and their names, and the equivalences between forms. One menu
 * entry, because a "não é divergência" on a form row is answered by one of
 * them; a tab each, because they are edited differently. Tabs navigate, so
 * each half has an address, as the golden set's do. What a capsule shell is
 * (#608) is set on the product's page in the catalogue since #636.
 */
export function FormSettingsTabs({ active }: { active: 'forms' | 'equivalences' }) {
  const tabs = [
    { key: 'forms' as const, label: 'Formas', to: { name: 'forms' as const } },
    {
      key: 'equivalences' as const,
      label: 'Equivalências',
      to: { name: 'formEquivalences' as const },
    },
  ]

  return (
    <div className="border-stroke-weak flex gap-1 border-b" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={active === tab.key}
          onClick={() => navigate(tab.to)}
          className={
            active === tab.key
              ? 'text-tPSemi text-text-brand border-fill-brand -mb-px border-b-2 px-3 py-2'
              : 'text-tP text-text-weak hover:text-text-strong -mb-px border-b-2 border-transparent px-3 py-2'
          }
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
